<h1 mat-dialog-title style="margin: 0px !important">
  {{ this.data?.Oid ? "Modifica" : "Creazione" }} Contatto
</h1>

<div mat-dialog-content>
  <form [formGroup]="form" fxLayout="column" fxLayoutGap="16px" autocomplete="off">
    <!-- Riga 1 -->
    <div fxLayout="row" fxLayoutGap="16px" fxFlexFill>
      <mat-form-field fxFlex>
        <mat-label>Nominativo</mat-label>
        <input matInput formControlName="Name" />
        <mat-error *ngIf="form.get('Name')?.hasError('required')"
          >* Campo obbligatorio</mat-error
        >
      </mat-form-field>

      <mat-form-field fxFlex>
        <mat-label>Indirizzo</mat-label>
        <input matInput formControlName="Address" type="search" />
      </mat-form-field>
    </div>

    <!-- Riga 2 -->
    <div fxLayout="row" fxLayoutGap="16px">
      <mat-form-field fxFlex>
        <mat-label>CAP</mat-label>
        <input matInput formControlName="ZipCode" />
      </mat-form-field>

      <mat-form-field fxFlex>
        <mat-label>Città</mat-label>
        <input matInput formControlName="City" />
      </mat-form-field>
    </div>

    <!-- Riga 3 -->
    <div fxLayout="row" fxLayoutGap="16px">
      <mat-form-field fxFlex>
        <mat-label>Provincia</mat-label>
        <input matInput formControlName="Province" />
      </mat-form-field>

      <mat-form-field fxFlex>
        <mat-label>Nazione</mat-label>
        <input matInput formControlName="Country" />
      </mat-form-field>
    </div>

    <!-- Riga 4 -->
    <div fxLayout="row" fxLayoutGap="16px">
      <mat-form-field fxFlex>
        <mat-label>Codice Fiscale</mat-label>
        <input matInput formControlName="FiscalCode" />
        <mat-error *ngIf="form.get('FiscalCode')?.hasError('pattern')">
          * Codice Fiscale non valido
        </mat-error>
      </mat-form-field>

      <mat-form-field fxFlex>
        <mat-label>Telefono</mat-label>
        <input matInput formControlName="Phone" />
        <mat-error *ngIf="form.get('Phone')?.hasError('pattern')">
          * Numero di telefono non valido
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Riga 5 -->
    <div fxLayout="row" fxLayoutGap="16px">
      <mat-form-field fxFlex>
        <mat-label>Email</mat-label>
        <input matInput formControlName="Email" />
        <mat-error *ngIf="form.get('Email')?.hasError('email')"
          >* Email non valida</mat-error
        >
      </mat-form-field>

      <mat-form-field fxFlex>
        <mat-label>PEC</mat-label>
        <input matInput formControlName="CertifiedEmail" />
      </mat-form-field>
      <mat-error *ngIf="form.get('CertifiedEmail')?.hasError('CertifiedEmail')">
        * PEC non valida
      </mat-error>
    </div>

    <!-- Riga 6 -->
    <div fxLayout="row" fxLayoutGap="16px">
      <mat-form-field fxFlex>
        <mat-label>Codice Contatto</mat-label>
        <input matInput formControlName="ContactCode" />
      </mat-form-field>

      <mat-form-field fxFlex>
        <mat-label>Codice Gruppo</mat-label>
        <input matInput formControlName="GroupCode" />
      </mat-form-field>
    </div>
  </form>
</div>

<div mat-dialog-actions class="d-flex space-between">
  <button mat-raised-button color="warn" [mat-dialog-close]="false">
    Annulla
  </button>

  <button mat-raised-button color="primary" (click)="onSubmit()">Salva</button>
</div>
